import { render, staticRenderFns } from "./PDFDropTable.vue?vue&type=template&id=3d1be313&scoped=true&"
import script from "./PDFDropTable.vue?vue&type=script&lang=js&"
export * from "./PDFDropTable.vue?vue&type=script&lang=js&"
import style0 from "./PDFDropTable.vue?vue&type=style&index=0&id=3d1be313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1be313",
  null
  
)

export default component.exports